import { FETCH_SESSION_LEVEL_OFFERS, GET_SESSION_LEVEL_OFFER, CREATE_SESSION_LEVEL_OFFER, UPDATE_SESSION_LEVEL_OFFER, DELETE_SESSION_LEVEL_OFFER } from 'actions/sessionLevelOffer';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  sessionLevelOffers: [],
  sessionLevelOfferDetail: {},
};

const sessionLevelOfferReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SESSION_LEVEL_OFFERS.REQUEST:
    case GET_SESSION_LEVEL_OFFER.REQUEST:
    case CREATE_SESSION_LEVEL_OFFER.REQUEST:
    case UPDATE_SESSION_LEVEL_OFFER.REQUEST:
    case DELETE_SESSION_LEVEL_OFFER.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_SESSION_LEVEL_OFFERS.SUCCESS: {
      return { ...state, isLoading: false, sessionLevelOffers: Array.isArray(payload) ? payload : [] };
    }

    case GET_SESSION_LEVEL_OFFER.SUCCESS: {
      return { ...state, isLoading: false, sessionLevelOfferDetail: Array.isArray(payload) ? payload[0] || {} : payload };
    }

    case CREATE_SESSION_LEVEL_OFFER.SUCCESS: {
      toast.success('Session level offer created successfully');
      return { ...state, isLoading: false };
    }

    case UPDATE_SESSION_LEVEL_OFFER.SUCCESS: {
      toast.success('Session level offer updated successfully');
      return { ...state, isLoading: false };
    }

    case DELETE_SESSION_LEVEL_OFFER.SUCCESS: {
      toast.success('Session level offer archived successfully');
      return { ...state, isLoading: false };
    }

    case FETCH_SESSION_LEVEL_OFFERS.FAIL:
    case GET_SESSION_LEVEL_OFFER.FAIL:
    case CREATE_SESSION_LEVEL_OFFER.FAIL:
    case UPDATE_SESSION_LEVEL_OFFER.FAIL:
    case DELETE_SESSION_LEVEL_OFFER.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return state;
  }
};

export default sessionLevelOfferReducer;
